/* =========================================================================
   TMD — Rescate de los textos de Judge.me en contenido cargado por AJAX
   Fecha: 2026-07-30

   Judge.me oculta tres textos con `visibility:hidden` desde el CSS que genera
   en el metafield `judgeme.settings` de la tienda:

       .jdgm-rev-widg__title        { visibility: hidden }
       .jdgm-rev-widg__summary-text { visibility: hidden }
       .jdgm-prev-badge__text       { visibility: hidden }

   Es intencional: evita el "flash" del texto en inglés antes de que su JS lo
   sustituya por la traducción configurada, y ese mismo JS los revela después.
   NO son reglas escritas a mano, así que no hay nada que borrar en su panel; y
   editar el metafield tampoco sirve porque la app lo regenera al sincronizar.

   El problema aparece en el contenido que llega por AJAX ("Productos
   relacionados" es el caso confirmado): para entonces el JS de Judge.me ya ha
   hecho su pasada, así que esos nodos se quedan ocultos y sin traducir.

   Este script solo toca los que SIGUEN ocultos pasado un margen, para no
   pelearse con la app cuando sí hace su trabajo.
   ========================================================================= */
(function () {
  'use strict';

  var BADGE = '.jdgm-prev-badge';
  var SOLO_REVELAR = '.jdgm-rev-widg__title, .jdgm-rev-widg__summary-text';
  var MARGEN_MS = 1200;

  function sigueOculto(el) {
    return el && !el.dataset.tmdBadgeFixed &&
           getComputedStyle(el).visibility === 'hidden';
  }

  function revelar(el) {
    el.style.setProperty('visibility', 'visible', 'important');
    el.dataset.tmdBadgeFixed = '1';
  }

  function traducir(n) {
    var patron = (window.jdgmSettings || {}).badge_n_reviews_text;
    if (!patron) return null;
    return patron
      .replace(/\{\{\s*n\s*\}\}/g, n)
      .replace(/(\S+)\/(\S+)/, function (_, singular, plural) {
        return String(n) === '1' ? singular : plural;
      });
  }

  function rescatarBadge(badge) {
    var texto = badge.querySelector('.jdgm-prev-badge__text');
    if (!sigueOculto(texto)) return;
    // el texto llega en inglés: se sustituye por la traducción de la app
    var n = badge.getAttribute('data-number-of-reviews');
    var etiqueta = n && traducir(n);
    if (etiqueta) texto.textContent = ' ' + etiqueta + ' ';
    revelar(texto);
  }


  /* ---------------------------------------------------------------------
     Imágenes del carrusel de reseñas (29/08/2026)

     Judge.me pinta las miniaturas de producto como <img> SIN src, con la URL
     en `data-src` y `data-src-retina`, y las rellena su propio lazy-load. En
     la home no llega a hacerlo nunca: quedan 15 imágenes con src vacío y iOS
     dibuja el interrogante azul de imagen rota encima de cada reseña.

     Aquí solo se copia data-src a src cuando sigue vacío, así que si algún día
     la app hace su trabajo esto no pisa nada.
     --------------------------------------------------------------------- */
  function rescatarImagen(im) {
    if (im.getAttribute('src')) return;
    var url = im.getAttribute('data-src');
    if (!url) return;
    var retina = im.getAttribute('data-src-retina');
    if (retina) im.setAttribute('srcset', url + ' 1x, ' + retina + ' 2x');
    im.setAttribute('loading', 'lazy');
    im.setAttribute('src', url);
  }


  /* ---------------------------------------------------------------------
     Título del widget de reseñas, por idioma (31/08/2026)

     Judge.me traduce solo los textos que NO se han personalizado: el botón sale
     como "Bewertung Schreiben" en alemán, pero el título del widget está
     personalizado en el panel ("Reseñas de Clientes") y su documentación dice
     que un texto personalizado en el idioma principal no se traduce a los demás.
     Vaciarlo no sirve, se probó dos veces: el widget se queda sin título.

     Así que el título y el contador se traducen aquí, que es lo que sí
     controlamos. Solo se toca si la página no está en español y el texto sigue
     siendo el español: si algún día la app lo traduce, este código no pisa nada.
     --------------------------------------------------------------------- */
  var JDGM_TITULOS = {
    en: 'Customer Reviews',
    fr: 'Avis clients',
    de: 'Kundenbewertungen',
    it: 'Recensioni dei clienti',
    pt: 'Avaliações de clientes'
  };
  var JDGM_RESENAS = {
    en: ['review', 'reviews'],
    fr: ['avis', 'avis'],
    de: ['Bewertung', 'Bewertungen'],
    it: ['recensione', 'recensioni'],
    pt: ['avaliação', 'avaliações']
  };

  function idiomaPagina() {
    var l = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
    return l === 'es' ? null : l;
  }

  /* Etiquetas sueltas del widget: el desplegable de orden se sirve en español en
     los seis idiomas (está personalizado en el panel, igual que el título) y el
     botón inglés sale como "Write a reseña" porque la app compone la frase con la
     palabra singular del idioma principal. Se sustituyen por texto exacto. */
  var JDGM_ETIQUETAS = {
    /* Variantes en Title Case y frases del formulario (auditoría i18n 08/10/2026) */
    "Mayor Calificación": {"en": "Highest rating", "fr": "Meilleure note", "de": "Beste Bewertung", "it": "Valutazione più alta", "pt": "Melhor classificação"},
    "Menor Calificación": {"en": "Lowest rating", "fr": "Note la plus basse", "de": "Schlechteste Bewertung", "it": "Valutazione più bassa", "pt": "Pior classificação"},
    "Solo Imágenes": {"en": "Pictures only", "fr": "Photos uniquement", "de": "Nur Bilder", "it": "Solo immagini", "pt": "Apenas imagens"},
    'Sort reviews by': { es: 'Ordenar por', en: 'Sort reviews by', fr: 'Trier par', de: 'Sortieren nach', it: 'Ordina per', pt: 'Ordenar por' },
    'Más recientes': { en: 'Most recent', fr: 'Plus récents', de: 'Neueste', it: 'Più recenti', pt: 'Mais recentes' },
    'Mayor calificación': { en: 'Highest rating', fr: 'Meilleure note', de: 'Beste Bewertung', it: 'Valutazione più alta', pt: 'Melhor classificação' },
    'Menor calificación': { en: 'Lowest rating', fr: 'Note la plus basse', de: 'Schlechteste Bewertung', it: 'Valutazione più bassa', pt: 'Pior classificação' },
    'Solo imágenes': { en: 'Pictures only', fr: 'Photos uniquement', de: 'Nur Bilder', it: 'Solo immagini', pt: 'Apenas imagens' },
    'Imágenes primero': { en: 'Pictures first', fr: "Photos d'abord", de: 'Bilder zuerst', it: 'Prima le immagini', pt: 'Imagens primeiro' },
    'Videos primero': { en: 'Videos first', fr: "Vidéos d'abord", de: 'Videos zuerst', it: 'Prima i video', pt: 'Vídeos primeiro' },
    'Más útiles': { en: 'Most helpful', fr: 'Plus utiles', de: 'Hilfreichste', it: 'Più utili', pt: 'Mais úteis' },
    'Write a reseña': { en: 'Write a review', es: 'Escribir una reseña', fr: 'Rédiger un avis', de: 'Bewertung schreiben', it: 'Scrivi una recensione', pt: 'Escrever uma avaliação' },
    'Write a review': { es: 'Escribir una reseña', fr: 'Rédiger un avis', de: 'Bewertung schreiben', it: 'Scrivi una recensione', pt: 'Escrever uma avaliação' },

    /* Variantes del widget antiguo, que Judge.me todavía servía en francés cuando
       el resto de idiomas ya tenía el nuevo. Mismas etiquetas, otra redacción. */
    'Sort by': { es: 'Ordenar por', en: 'Sort by', fr: 'Trier par', de: 'Sortieren nach', it: 'Ordina per', pt: 'Ordenar por' },
    'Más Recientes': { en: 'Most recent', fr: 'Plus récents', de: 'Neueste', it: 'Più recenti', pt: 'Mais recentes' },
    'Mejor Rating': { en: 'Highest rating', fr: 'Meilleure note', de: 'Beste Bewertung', it: 'Valutazione più alta', pt: 'Melhor classificação' },
    'Peor Rating': { en: 'Lowest rating', fr: 'Note la plus basse', de: 'Schlechteste Bewertung', it: 'Valutazione più bassa', pt: 'Pior classificação' },
    'Sólo Fotos': { en: 'Pictures only', fr: 'Photos uniquement', de: 'Nur Bilder', it: 'Solo immagini', pt: 'Apenas imagens' },
    'Videos Primero': { en: 'Videos first', fr: "Vidéos d'abord", de: 'Videos zuerst', it: 'Prima i video', pt: 'Vídeos primeiro' },
    'Más Útiles': { en: 'Most helpful', fr: 'Plus utiles', de: 'Hilfreichste', it: 'Più utili', pt: 'Mais úteis' },

    /* Formulario de escribir reseña. Sale en castellano dentro de los otros cinco
       idiomas por el mismo motivo que el resto: está personalizado en el panel. */
    '¿Cómo calificarías este producto?': { en: 'How would you rate this product?', fr: 'Comment noteriez-vous ce produit ?', de: 'Wie würden Sie dieses Produkt bewerten?', it: 'Come valuteresti questo prodotto?', pt: 'Como classificarias este produto?' },
    'Título de la Reseña': { en: 'Review title', fr: "Titre de l'avis", de: 'Titel der Bewertung', it: 'Titolo della recensione', pt: 'Título da avaliação' },
    'Sobre ti': { en: 'About you', fr: 'À propos de vous', de: 'Über Sie', it: 'Su di te', pt: 'Sobre ti' },
    'Por favor, cuéntanos más sobre ti.': { en: 'Please tell us a bit about yourself.', fr: 'Parlez-nous un peu de vous.', de: 'Bitte erzählen Sie uns etwas über sich.', it: 'Raccontaci qualcosa di te.', pt: 'Conta-nos um pouco sobre ti.' },
    'Respetamos tu privacidad.': { en: 'We respect your privacy.', fr: 'Nous respectons votre vie privée.', de: 'Wir respektieren Ihre Privatsphäre.', it: 'Rispettiamo la tua privacy.', pt: 'Respeitamos a tua privacidade.' },
    'No será visible para otros clientes.': { en: 'It will not be visible to other customers.', fr: 'Ne sera pas visible par les autres clients.', de: 'Für andere Kunden nicht sichtbar.', it: 'Non sarà visibile agli altri clienti.', pt: 'Não será visível para outros clientes.' },
    'Reseña como anónimo': { en: 'Post anonymously', fr: 'Publier anonymement', de: 'Anonym bewerten', it: 'Recensisci in anonimo', pt: 'Avaliar anonimamente' },
    'Compartir una foto o video': { en: 'Share a photo or video', fr: 'Partager une photo ou une vidéo', de: 'Foto oder Video teilen', it: 'Condividi una foto o un video', pt: 'Partilhar uma foto ou vídeo' },
    'Sube una foto o video para apoyar tu reseña.': { en: 'Upload a photo or video to support your review.', fr: 'Ajoutez une photo ou une vidéo à votre avis.', de: 'Laden Sie ein Foto oder Video zu Ihrer Bewertung hoch.', it: 'Carica una foto o un video a supporto della recensione.', pt: 'Carrega uma foto ou vídeo para apoiar a tua avaliação.' },
    'Siguiente': { en: 'Next', fr: 'Suivant', de: 'Weiter', it: 'Avanti', pt: 'Seguinte' },
    'Atrás': { en: 'Back', fr: 'Retour', de: 'Zurück', it: 'Indietro', pt: 'Voltar' },
    'Cerrar': { en: 'Close', fr: 'Fermer', de: 'Schließen', it: 'Chiudi', pt: 'Fechar' },
    '¡Gracias por tu reseña!': { en: 'Thanks for your review!', fr: 'Merci pour votre avis !', de: 'Danke für Ihre Bewertung!', it: 'Grazie per la tua recensione!', pt: 'Obrigado pela tua avaliação!' },
    'La estamos procesando y aparecerá en la tienda pronto.': { en: 'We are processing it and it will appear in the store soon.', fr: "Nous la traitons et elle apparaîtra bientôt sur la boutique.", de: 'Wir verarbeiten sie und sie erscheint bald im Shop.', it: 'La stiamo elaborando e apparirà presto nel negozio.', pt: 'Estamos a processá-la e aparecerá em breve na loja.' }
  };

  /* Trozos que viajan DENTRO de una frase ya traducida: en alemán salía
     "Inhalt der Bewertung (Obligatorio)". Se sustituyen aunque no sean el texto
     completo del nodo. */
  var JDGM_TROZOS = {
    '(Obligatorio)': { en: '(Required)', fr: '(Obligatoire)', de: '(Pflichtfeld)', it: '(Obbligatorio)', pt: '(Obrigatório)' },
    '(Opcional)': { en: '(Optional)', fr: '(Facultatif)', de: '(Optional)', it: '(Facoltativo)', pt: '(Opcional)' }
  };

  function traducirEtiquetas(raiz, idioma) {
    /* Solo se recorren los subárboles de Judge.me. Recorrer el documento entero en
       cada mutación costaba caro: el widget añade cientos de nodos y el hilo
       principal se quedaba bloqueado (TBT de 20 a 160 ms y el LCP del hero, que se
       descarga en 67 KB y va con preload, subió a 8 s de puro render delay). */
    var zonas = [];
    if (raiz.matches && raiz.matches('[class*="jdgm"], [class*="jm-"]')) zonas.push(raiz);
    Array.prototype.push.apply(zonas, raiz.querySelectorAll('[class*="jdgm"], [class*="jm-"]'));
    if (!zonas.length) return;

    var nodos = [];
    zonas.forEach(function (zona) {
      var caminante = document.createTreeWalker(zona, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = caminante.nextNode())) nodos.push(n);
    });
    nodos.forEach(function (nodo) {
      var t = nodo.textContent.trim();
      var tabla = JDGM_ETIQUETAS[t];
      if (tabla && tabla[idioma]) {
        nodo.textContent = nodo.textContent.replace(t, tabla[idioma]);
        return;
      }
      Object.keys(JDGM_TROZOS).forEach(function (trozo) {
        var destino = JDGM_TROZOS[trozo][idioma];
        if (destino && nodo.textContent.indexOf(trozo) >= 0) {
          nodo.textContent = nodo.textContent.split(trozo).join(destino);
        }
      });
    });
  }

  function traducirWidget(raiz) {
    if (!raiz.querySelectorAll) return;
    var lang = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
    // el desplegable de orden y el botón fallan también en español ("Sort reviews
    // by", "Write a reseña"), así que las etiquetas se revisan en los seis idiomas
    if (raiz.querySelector && (raiz.querySelector('[class*="jdgm"], [class*="jm-"]') || raiz.className)) {
      traducirEtiquetas(raiz, lang);
    }

    var idioma = idiomaPagina();
    if (!idioma || !JDGM_TITULOS[idioma]) return;

    // dos selectores: Judge.me está desplegando su widget nuevo por fases y
    // en francés todavía se servía el antiguo cuando se escribió esto
    Array.prototype.forEach.call(
      raiz.querySelectorAll('.jm-review-widget-minimal-header__title, .jdgm-rev-widg__title'),
      function (el) {
        if (/Reseñas de Clientes/i.test(el.textContent)) {
          el.textContent = JDGM_TITULOS[idioma];
        }
      }
    );

    // resumen del widget antiguo: "Basado en 137 reseñas"
    Array.prototype.forEach.call(
      raiz.querySelectorAll('.jdgm-rev-widg__summary-text'),
      function (el) {
        var m = el.textContent.match(/^Basado en (\d[\d.,]*) reseñas?$/);
        if (!m) return;
        var p = JDGM_RESENAS[idioma];
        var n = m[1].replace(/[.,]/g, '');
        var plantilla = {
          en: 'Based on {n} {p}', fr: 'Basé sur {n} {p}', de: 'Basierend auf {n} {p}',
          it: 'Basato su {n} {p}', pt: 'Com base em {n} {p}'
        }[idioma];
        el.textContent = plantilla.replace('{n}', m[1]).replace('{p}', n === '1' ? p[0] : p[1]);
      }
    );

    // "137 reseñas" → solo se cambia la palabra, el número lo pone la app
    var palabras = JDGM_RESENAS[idioma];
    Array.prototype.forEach.call(raiz.querySelectorAll('.jm-text'), function (el) {
      var m = el.textContent.match(/^(\d[\d.,]*)\s+reseñas?$/);
      if (!m) return;
      var n = m[1].replace(/[.,]/g, '');
      el.textContent = m[1] + ' ' + (n === '1' ? palabras[0] : palabras[1]);
    });
  }

  function revisar(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    if (raiz.matches && raiz.matches(BADGE)) rescatarBadge(raiz);
    Array.prototype.forEach.call(raiz.querySelectorAll(BADGE), rescatarBadge);
    // estos dos ya vienen traducidos en el HTML: basta con devolverles la visibilidad
    Array.prototype.forEach.call(raiz.querySelectorAll(SOLO_REVELAR), function (el) {
      if (sigueOculto(el)) revelar(el);
    });
    Array.prototype.forEach.call(raiz.querySelectorAll('img[data-src]'), rescatarImagen);
    traducirWidget(raiz);
  }

  function programar(raiz) {
    // en hueco libre: nada de esto es urgente y compite con el pintado del hero
    setTimeout(function () {
      if (window.requestIdleCallback) {
        requestIdleCallback(function () { revisar(raiz); }, { timeout: 2000 });
      } else {
        revisar(raiz);
      }
    }, MARGEN_MS);
  }

  /* Una sola pasada por tanda de mutaciones. Antes se programaba una revisión por
     cada nodo añadido, y el widget de reseñas añade cientos de golpe. */
  var pendiente = false;
  new MutationObserver(function (mutaciones) {
    if (pendiente) return;
    var hayNodos = mutaciones.some(function (m) { return m.addedNodes.length; });
    if (!hayNodos) return;
    pendiente = true;
    setTimeout(function () {
      pendiente = false;
      if (window.requestIdleCallback) {
        requestIdleCallback(function () { revisar(document); }, { timeout: 2000 });
      } else {
        revisar(document);
      }
    }, MARGEN_MS);
  }).observe(document.documentElement, { childList: true, subtree: true });

  programar(document);
})();
